import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import classnames from 'classnames';
import _ from 'lodash';
import './FleetRegistration.css';
import LeftPan from './ChildComponents/LeftPan';
import VehicleType from './ChildComponents/VehicleType';
import VehicleMake from './ChildComponents/VehicleMake';
import VehicleCount from './ChildComponents/VehicleCount';
import FleetService from '../../services/FleetService';
import { messages } from '../../constants/constant.message';
import ModalService from '../../services/ModalService';

class FleetRegistration extends Component {

  isMobile = false;

  constructor(props) {
    super(props);
    this.state = {
      temp_id: this.props.temp_id,
      visibleArea: 'vehicleType',
      fleetData: [],
      controls: {
        fleetId: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null,
          databaseFieldName: 'fleet_id'
        },
        vehicleType: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null,
          databaseFieldName: 'vehicle_type_id'
        },
        vehicleBrand: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null,
          databaseFieldName: 'vehicle_type_brand_id'
        },
        fourWheeler: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null,
          databaseFieldName: '4_wheeler'
        },
        sixWheeler: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null,
          databaseFieldName: '6_wheeler'
        },
        tenWheeler: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null,
          databaseFieldName: '10_wheeler'
        },
        twelveWheeler: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null,
          databaseFieldName: '12_wheeler'
        },
        fourteenWheeler: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null,
          databaseFieldName: '14_wheeler'
        },
        sixteenWheeler: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null,
          databaseFieldName: '16_wheeler'
        },
        eighteenWheeler: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null,
          databaseFieldName: '18_wheeler'
        },
        twentyTwoWheeler: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null,
          databaseFieldName: '22_wheeler'
        },
        twentyEightWheeler: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null,
          databaseFieldName: '28_wheeler'
        },
      },
      currentFleetData: {
        'vehicle_type_id': '',
        'type_name': '',
        'vehicle_type_brand_id': '',
        'brand_name': '',
        'brand_image_url': '',
        'number_of_tyres_vehicle_count': {}
      },
      isLoaded: false,
      isEdit: false,
      editIndex: -1
    }
    const { fleetData } = this.state;
    this.getFleetData();
    this.checkUserAgent();
    this.setState({ fleetData });
    this.leftPanChild = React.createRef();
  }


  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onSubmitClick = () => {
    try {
      let { currentFleetData } = this.state;
      currentFleetData = this.parseObj();
      const obj = this.validateTotalTyreCount(currentFleetData);
      currentFleetData.count = obj.tyre;
      if (obj.valid) {
        this.updateProfileCount(currentFleetData, obj);
        this.proceedToSave(currentFleetData, obj);
      } else {
        //const tyreCount = (obj.type || '').toLowerCase() === 'truck' ? this.props.truck.value : this.props.bus.value;
        // ModalService.openAlertWithPopup('', `Seems like you have added only ${obj.tyre} ${obj.type} while the total count shows ${tyreCount} ${obj.type}. Do you want to add more ${obj.type}?`, 'warning', ['This number is fine', 'Add more'], (isConfirm) => {
        //   if (!isConfirm) {
        //     this.updateProfileCount(currentFleetData, obj);
        //     this.proceedToSave(currentFleetData, obj);
        //   } else {
        //     this.proceedToSave(currentFleetData, obj, 'doNotRedirectToProfile');
        //     this.resetControls();
        //     this.setState({ visibleArea: 'vehicleType' });
        //   }
        // });
        this.proceedToSave(currentFleetData, obj, 'doNotRedirectToProfile');
        this.resetControls();
        this.setState({ visibleArea: 'vehicleType' });
      }
    } catch (error) {
      console.log(error);
      ModalService.openAlert('Oops !', messages.FLEET_REGISTRATION.ERRORMESSAGE, 'error');
    }
  }

  onUpdateClick = () => {
    try {
      const { controls } = this.state;
      const updateObj = this.parseObj();
      updateObj.fleet_id = controls.fleetId.value;
      const obj = this.validateTotalTyreCount(updateObj);
      updateObj.count = obj.tyre;
      if (obj.valid) {
        this.updateProfileCount(updateObj, obj);
        this.proceedToUpdate(updateObj);
      } else {
        const tyreCount = (obj.type || '').toLowerCase() === 'truck' ? this.props.truck.value : this.props.bus.value;
        ModalService.openAlertWithPopup('', `Seems like you have added only ${obj.tyre} ${obj.type} while the total count shows ${tyreCount} ${obj.type}. Do you want to add more ${obj.type}?`, 'warning', ['This number is fine', 'Add more'], (isConfirm) => {
          if (!isConfirm) {
            this.updateProfileCount(updateObj, obj);
            this.proceedToUpdate(updateObj);
          } else {
            this.proceedToUpdate(updateObj, 'doNotRedirectToProfile');
            this.resetControls();
            this.setState({ visibleArea: 'vehicleType' });
          }
        });
      }

    } catch (error) {
      console.log(error);
      ModalService.openAlert('Oops !', messages.FLEET_REGISTRATION.ERRORMESSAGE, 'error');
    }
  }

  onCancelClick = () => {
    ModalService.openAlertWithPopup(messages.FLEET_REGISTRATION.ONCANCELCLICKTITLE, messages.FLEET_REGISTRATION.ONCANCELCLICKMESSAGE, 'warning', ['No', 'Yes'], (isConfirm) => {
      if (isConfirm) {
        this.props.buildMyFleetClick(false);
      }
    });
  }

  async getFleetData() {
    let { fleetData, isLoaded, visibleArea } = this.state;
    isLoaded = false;
    try {
      const { data } = await FleetService.getFleetData(this.state.temp_id ? this.state.temp_id : null);
      if (data) {
        fleetData = data.data;
      }
      isLoaded = true;

      fleetData.forEach((fleet) => {
        fleet.data_length = fleet.data.length;
      });

      if (fleetData.length) {
        visibleArea = 'editMode';
      }

      this.setState({ fleetData, isLoaded, visibleArea });
      this.leftPanChild.current.updateState();
    } catch (error) {
      isLoaded = true;
      this.setState({ isLoaded });
      console.log(error);
    }
  }

  resetControls = () => {
    const { controls } = this.state;
    const { fleetId, vehicleType, vehicleBrand, fourWheeler, sixWheeler, tenWheeler,
      twelveWheeler, fourteenWheeler, sixteenWheeler, eighteenWheeler, twentyTwoWheeler, twentyEightWheeler } = controls;

    fleetId.value = '';
    vehicleType.value = '';
    vehicleBrand.value = '';
    fourWheeler.value = '';
    sixWheeler.value = '';
    // eightWheeler.value = '';
    tenWheeler.value = '';
    twelveWheeler.value = '';
    fourteenWheeler.value = '';
    sixteenWheeler.value = '';
    eighteenWheeler.value = '';
    twentyTwoWheeler.value = '';
    twentyEightWheeler.value = '';
  }

  proceedToUpdate = async (obj, param) => {
    delete obj.type_name;
    delete obj.brand_name;
    delete obj.brand_image_url;

    if (this.state.temp_id) {
      obj.temp_id = this.state.temp_id;
    }

    const { data } = await FleetService.updateFleet(obj);

    if (data.success) {
      ModalService.openAlert('Congratulations !', messages.FLEET_REGISTRATION.UPDATEREGISTRATION, 'success');
    }

    if (param !== 'doNotRedirectToProfile') {
      this.props.buildMyFleetClick(false);
    }
  }

  updateState = (params) => {
    let { currentFleetData, controls, fleetData } = this.state;
    params.isEdit = !!params.isEdit;
    if (!params.isEdit) {
      currentFleetData = this.parseObj();
      fleetData.forEach((fleet) => {
        if ((fleet.type || '').toLowerCase() === (controls.vehicleType.value.name || '').toLowerCase()) {
          fleet.data[fleet.data_length] = currentFleetData;
        }
      });
    }

    if (!params.isEdit) {
      currentFleetData = this.parseObj();
    }

    if (params.isEdit && params.editIndex > -1) {
      fleetData.forEach((fleet) => {
        if ((fleet.type || '').toLowerCase() === (controls.vehicleType.value.name || '').toLowerCase() && fleet.data && fleet.data.length) {
          fleet.data[params.editIndex].number_of_tyres_vehicle_count = params.updatedCount;
        }
      });
    }

    this.setState({ ...params, fleetData });
  }

  validateTotalTyreCount = ({ type_name = '' }) => {
    const { fleetData } = this.state;
    let totalTyre = 0;
    _.forEach(fleetData, (fleet) => {
      if ((fleet.type || '').toLowerCase() === type_name.toLowerCase()) {
        _.forEach(fleet.data, (d) => {
          if (d && d.number_of_tyres_vehicle_count && Object.keys(d.number_of_tyres_vehicle_count).length) {
            totalTyre += _.sum(Object.values(d.number_of_tyres_vehicle_count || {}));
          }
        });
      }
    });

    if ((type_name || '').toLowerCase() === 'truck' && (this.props.truck.value || 0) > totalTyre) {
      return {
        type: type_name,
        tyre: totalTyre,
        valid: false
      };
    } if ((type_name || '').toLowerCase() === 'bus' && (this.props.bus.value || 0) > totalTyre) {
      return {
        type: type_name,
        tyre: totalTyre,
        valid: false
      };
    }

    return {
      type: type_name,
      tyre: totalTyre,
      valid: true
    };
  }

  addMoreTrucks = () => {
    this.updateState({ visibleArea: 'vehicleType' });
  }

  checkUserAgent() {
    this.isMobile = false;
    const ua = navigator.userAgent;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)) {
      this.isMobile = true;
      return 'mobile';
    } if (/Chrome/i.test(ua)) {
      return 'chrome';
    }
    return 'other';

  }

  updateProfileCount(currentFleetData, obj) {
    const truck = this.props.truck;
    const bus = this.props.bus;
    if ((currentFleetData.type_name || '').toLowerCase() === 'truck') {
      truck.value = obj.tyre;
    } else {
      bus.value = obj.tyre;
    }
    this.props.updateTruckBusData({ truck, bus });
  }

  async proceedToSave(currentFleetData, obj, param) {

    delete currentFleetData.type_name;
    delete currentFleetData.brand_name;
    delete currentFleetData.brand_image_url;

    if (this.state.temp_id) {
      currentFleetData.temp_id = this.state.temp_id;
    }
    try {
      const { data } = await FleetService.postFleetRegistration(currentFleetData);

      if (data.success) {
        ModalService.openAlert('Congratulations !', messages.FLEET_REGISTRATION.SUCCESSREGISTRATION, 'success');
      }
      this.resetControls();
      this.getFleetData();
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
        ModalService.openAlert('', e.response.data.error[0].message, 'error');
      }
    }
    // if (param !== 'doNotRedirectToProfile') {
    //   this.props.buildMyFleetClick(false);
    // } else {
    //   this.getFleetData();
    // }
  }

  parseObj() {
    const { controls } = this.state;
    const obj = {
      'vehicle_type_id': controls.vehicleType.value && controls.vehicleType.value.vehicle_type_id,
      'type_name': controls.vehicleType.value && controls.vehicleType.value.name,
      'vehicle_type_brand_id': controls.vehicleBrand.value && controls.vehicleBrand.value.brand_id,
      'brand_name': controls.vehicleBrand.value && controls.vehicleBrand.value.name,
      'brand_image_url': controls.vehicleBrand.value && controls.vehicleBrand.value.image_url
    };

    if (controls.vehicleType.value && (controls.vehicleType.value.name || '').toLowerCase() === 'truck') {
      obj.number_of_tyres_vehicle_count = {
        '6_wheeler': +(controls.sixWheeler.value || 0),
        '10_wheeler': +(controls.tenWheeler.value || 0),
        '12_wheeler': +(controls.twelveWheeler.value || 0),
        '14_wheeler': +(controls.fourteenWheeler.value || 0),
        '16_wheeler': +(controls.sixteenWheeler.value || 0),
        '18_wheeler': +(controls.eighteenWheeler.value || 0),
        '22_wheeler': +(controls.twentyTwoWheeler.value || 0),
        '28_wheeler': +(controls.twentyEightWheeler.value || 0)
      };
    } else {
      obj.number_of_tyres_vehicle_count = {
        '4_wheeler': +(controls.fourWheeler.value || 0),
        '6_wheeler': +(controls.sixWheeler.value || 0),
        // '8_wheeler': +(controls.eightWheeler.value || 0)
      };
    }

    return obj;
  }



  render() {
    const { visibleArea, controls, currentFleetData, fleetData, isLoaded, isEdit, editIndex } = this.state;
    return <div id="fleet-registration">
      {isLoaded && <Row>
        {
          this.props.from !== 'profile' &&
          <Col xl="1" md="1" xs="1" />
        }

        <Col className={classnames({ 'col-12 col-xl-12 col-md-12 col-sm-12 col-xs-12': this.isMobile || this.props.from === 'profile', 'col-10 col-xl-10 col-md-10 col-sm-12 col-xs-12': !this.isMobile && this.props.from !== 'profile' })}>
          {
            <Row style={{ marginLeft: '2px' }}>
              <span className="Fleet-Registration">Fleet Registration</span>
              &nbsp;&nbsp;
              <span className="custom-link" onClick={this.onCancelClick} style={{ marginTop: '5px' }}>Cancel</span>
            </Row>
          }

          <div className={classnames({ 'disable-text-box-margin': !this.isMobile, 'enable-text-box-margin': this.isMobile }, 'row')}>
            {
              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" style={this.isMobile ? { padding: '4px' } : {}}>
                <LeftPan ref={this.leftPanChild} controls={controls} currentFleetData={currentFleetData} fleetData={fleetData} updateState={this.updateState}
                  temp_id={this.state.temp_id} />
              </div>
            }
            {/* {
              !this.isMobile &&
              <div className="col-lg-1 col-md-1 col-sm-0 col-xs-0" style={{ padding: '0' }} />
            } */}
            <div className={classnames({ 'p': this.isMobile }, 'col-lg-6 col-md-6 col-sm-12 col-xs-12')} style={this.isMobile ? { padding: '15px' } : { paddingLeft: '45px' }} >
              <Card className={classnames({ 'box-shadow-apply': !this.isMobile, 'box-shadow-remove': this.isMobile }, 'row')} style={{ minHeight: '500px' }}>
                <CardBody>
                  {
                    visibleArea === 'editMode' &&
                    <>
                      <Row>
                        <Col>
                          <div className="click-on-the-Edit-icon">
                            Click on the Edit icon to edit the vehicle details
                          </div>
                          <div className="fleet-register-or">
                            OR
                          </div>
                          <div onClick={this.addMoreTrucks} className="Add-More-Trucks">
                            Add More
                          </div>
                        </Col>
                      </Row>
                    </>
                  }
                  {
                    visibleArea === 'vehicleType' ? <VehicleType controls={controls} updateState={this.updateState} fleetData={fleetData} onCancelClick={this.onCancelClick} /> : ''
                  }
                  {
                    visibleArea === 'vehicleMake' ? <VehicleMake
                      controls={controls} updateState={this.updateState} fleetData={fleetData} onCancelClick={this.onCancelClick}
                      temp_id={this.state.temp_id} /> : ''
                  }
                  {
                    visibleArea === 'vehicleCount' ? <VehicleCount controls={controls} updateState={this.updateState} onSubmitClick={this.onSubmitClick} onUpdateClick={this.onUpdateClick} onCancelClick={this.onCancelClick} isEdit={isEdit} editIndex={editIndex} /> : ''
                  }
                </CardBody>
              </Card>

            </div>
          </div>
        </Col>
        <Col xl="1" md="1" xs="1" />
      </Row>}
    </div>;
  }
}

export default FleetRegistration;
